import { lazy, Suspense } from "react"
import { Redirect, Route, Switch } from "react-router-dom"
import LoadingScreen from "src/components/Common/LoadingScreen"
import DashboardLayout from "src/layouts/DashboardLayout"
import { ReactNotifications } from "react-notifications-component"
import Aprobadores from "./aprobadores"

const Dashboard = lazy(() => import("./dashboard/index"))
const Alerta = lazy(() => import("./alertas"))
const BitacoraDigital = lazy(
  () => import("./bitacoraDigital/ListBitacora/ListarBitacora")
)
const BitacorasRechazadas = lazy(() => import("./bitacoraDigital/Rechazadas"))
const VisitasAnticipadas = lazy(() => import("./visitasAnticipadas/index"))
const Ingresos = lazy(() => import("./ingresos"))
const Listas = lazy(() => import("./listas"))
const Eventos = lazy(() => import("./eventos"))
const Rondas = lazy(() => import("./rondas"))
const Familia = lazy(() => import("./familia"))
const Reservas = lazy(() => import("./listaReservas"))
const Profile = lazy(() => import("../viewAdministrador/profile"))
const Verificacion2FA = lazy(
  () => import("../viewAdministrador/profile/2fa/Verificacion2FA")
)
const NotFoundView = lazy(() => import("../errors/NotFoundView"))
const Guardias = lazy(() => import("../viewAdministrador/guardias/index"))
const Guardia = ({ match }) => (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <ReactNotifications />
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/dashboard`} />
        <Route
          path={`${match.url}/dashboard`}
          exact
          render={props => <Dashboard {...props} />}
        />
        <Route
          path={`${match.url}/alerta`}
          render={props => <Alerta {...props} />}
        />
        <Route
          path={`${match.url}/bitacoraDigital`}
          render={props => <BitacoraDigital {...props} />}
        />
        <Route
          path={`${match.url}/bitacoraRechazada`}
          render={props => <BitacorasRechazadas {...props} />}
        />
        <Route
          path={`${match.url}/visitasAnticipadas`}
          render={props => <VisitasAnticipadas {...props} />}
        />
        <Route
          path={`${match.url}/ingresos`}
          render={props => <Ingresos {...props} />}
        />
        <Route
          path={`${match.url}/listas`}
          render={props => <Listas {...props} />}
        />
        <Route
          path={`${match.url}/eventos`}
          render={props => <Eventos {...props} />}
        />
        <Route
          path={`${match.url}/rondas`}
          render={props => <Rondas {...props} />}
        />
        <Route
          path={`${match.url}/reservas`}
          render={props => <Reservas {...props} />}
        />
        <Route
          path={`${match.url}/familia`}
          render={props => <Familia {...props} />}
        />
        <Route
          path={`${match.url}/aprobadores`}
          render={props => <Aprobadores {...props} />}
        />
        <Route
          path={`${match.url}/perfil`}
          exact
          render={props => <Profile {...props} />}
        />
        <Route
          path={`${match.url}/perfil/two_factor_auth`}
          exact
          render={props => <Verificacion2FA {...props} />}
        />
        <Route
          path={`${match.url}/gestionarGuardias`}
          render={props => <Guardias {...props} />}
        />
        <Route render={props => <NotFoundView {...props} />} />
      </Switch>
    </Suspense>
  </DashboardLayout>
)

export default Guardia
